(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $('body').on('click', '.ya-share2 a', function () {
            var $parent = $(this).closest('a');
            if ($parent.length === 0 || $parent.hasClass('ya-share2__link_more')) {
                console.log('deny');
                return;
            }

            $.post('/blog/update-re-posts.html', {
                id: $('#post-id').val(),
                alias: $('#post-alias').val()
            }, function (data) {
                if (data.success) {
                    var $counter = $('#reposts-count');
                    var count = parseInt($counter.text(), 10);
                    $counter.text(count + 1);
                }
            });
        });
    }, {}] }, {}, [1]);